import { render } from "./CardTotal.vue?vue&type=template&id=1b2dccd0&scoped=true"
import script from "./CardTotal.vue?vue&type=script&lang=js"
export * from "./CardTotal.vue?vue&type=script&lang=js"

import "./CardTotal.vue?vue&type=style&index=0&id=1b2dccd0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2dccd0"]])

export default __exports__